import { constantRoutes } from '@/router'
// import { getAllUserMenu } from '@/api/sysTool/sysMenu'
// import router from '@/router'
// import VueRouter from 'vue-router'
import store from '@/store'

/* Layout */
// import Layout from '@/views/layout'
// import parentView from '@/components/parent-view'

const routes = {
  state: {
    // 菜单栏
    sidebarRouters: [],
    // 页签
    tagView: [],

    badge: {
      DropshippingOrders: 0
    }, // 侧边栏 标记内容
    hideMap: { 'Affiliate': 1 } // 需要隐藏的按钮
  },

  mutations: {
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    },
    ADD_TAG_VIEW: (state, tv) => {
      state.tagView.push(tv)
    },
    Delete_TAG_VIEW: (state, index) => {
      state.tagView.splice(index, 1)
    },
    SET_BADGE(state, data) {
      // state.badge
      Object.assign(state.badge, data)
    },
    SET_ROUTER_HIDE(state, data) {
      // console.log(data)
      state.hideMap[data.name] = data.value
    }
  },

  actions: {
    // 生成路由
    GenerateRoutes({ commit }) {
      return new Promise((resolve) => {
        var sidebarRoutes = []
        // 新路由
        // 已登录向后端请求路由数据
        var hasLogin = store.getters.hasLogin
        if (hasLogin) {
          // getAllUserMenu().then((res) => {
          //   if (res.success) {
          //     // 构建导航
          //     if(res.data){
          //       sidebarRoutes = JSON.parse(JSON.stringify(res.data))
          //       filterAsyncRouter(sidebarRoutes)
          //       sidebarRoutes.push({ path: '*', redirect: '/404', hidden: true })
          //       if (sidebarRoutes && sidebarRoutes.length > 0) router.addRoutes(sidebarRoutes)
          //     }
          //     commit('SET_SIDEBAR_ROUTERS', JSON.parse(JSON.stringify(constantRoutes)).concat(sidebarRoutes))
          //   } else{
          //     sidebarRoutes = JSON.parse(JSON.stringify(constantRoutes))
          //     sidebarRoutes.push({ path: '*', redirect: '/404', hidden: true })
          //     commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
          //   }
          //   resolve()
          // })
		  // console.log(111, constantRoutes);
		  let tag = store.state.user.menuIds
		  let arr = []
		  // let tag = store.getters.hasLogin
		  constantRoutes.forEach((item) => {
			  if (item.meta && item.meta.tag) {
				  if (tag.indexOf(item.meta.tag) >= 0) {
					  if (item.children.length) {
						  item.children = item.children.filter((i) => { return !i.meta.tag || tag.indexOf(i.meta.tag) >= 0 })
					  }
					  arr.push(item)
				  }
			  } else {
				  arr.push(item)
			  }
		  })
          sidebarRoutes = JSON.parse(JSON.stringify(store.state.user.isDefault ? constantRoutes : arr))
          sidebarRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
		  const flag = store.state.user.isDefault ? store.state.user.isDefault : tag.indexOf('1') >= 0
          resolve(flag)
        } else {
          // 未登录直接构造默认路由
          sidebarRoutes = JSON.parse(JSON.stringify(constantRoutes))
          sidebarRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_SIDEBAR_ROUTERS', sidebarRoutes)
          resolve()
        }
      })
    },
    AddTagView({ commit, state }, tv) {
      return new Promise((resolve) => {
        var index = state.tagView.findIndex((el) => {
          return el.meta.guid === tv.meta.guid
        })
        if (index < 0) {
          commit('ADD_TAG_VIEW', tv)
          index = state.tagView.length - 1
        }
        resolve(index)
      })
    },
    DeleteTagView({ commit, state }, index) {
      return new Promise((resolve) => {
        if (index >= 0 && index < state.tagView.length && !state.tagView[index].affix) {
          commit('Delete_TAG_VIEW', index)
        }
        if (index >= state.tagView.length) index = state.tagView.length - 1
        resolve(index)
      })
    }
  }
}

// 遍历后台传来的路由字符串
// function filterAsyncRouter(asyncRouterMap, isLayout = true) {
//   return asyncRouterMap.map((el) => {
//     el.alwaysShow = true
//     el.meta = {
//       title: el.title,
//       icon: el.icon,
//       permits: el.permits,
//       permit: el.permit,
//       guid: el.guid,
//     }
//     if (isLayout) el.component = Layout
//     else if (el.children && el.children.length > 0) el.component = parentView
//     else {
//       var path = el.component && el.component.length > 0 ? el.component : 'static/404'
//       el.component = loadView(path)
//     }
//     // 有下级菜单
//     if (el && el.children && el.children.length > 0) {
//       filterAsyncRouter(el.children, false)
//     } else delete el['children']
//   })
// }

export const loadView = (path) => {
  return (resolve) => require([`@/views/${path}`], resolve)
}
export default routes
